import { Grid } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import ForfaitJours from '../France/ForfaitJours'
import JoursParAn from '../France/JoursParAn'

interface Props {
  contractVersion: ContractVersionPageContractVersionFragment
}

const Italy = ({ contractVersion }: Props) => {
  const canEdit = contractVersion._policies?.edit?.can ?? false
  const hasForfaitJours = !!contractVersion.frForfaitJours
  const joursParAn = hasForfaitJours ? contractVersion.frJoursParAn : null
  const showJoursParAn = (hasForfaitJours && !!joursParAn) || canEdit

  return (
    <Grid variant="fixed">
      <ForfaitJours hasForfaitJours={hasForfaitJours} />
      {showJoursParAn && <JoursParAn jours={joursParAn ?? undefined} />}
    </Grid>
  )
}

export default Italy
